var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,25.25A14.75,14.75,0,1,0,54.75,40,14.76655,14.76655,0,0,0,40,25.25Zm0,28A13.25,13.25,0,1,1,53.25,40,13.26491,13.26491,0,0,1,40,53.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38,44.93945l-5.46973-5.46972-1.06054,1.06054,6,6a.74971.74971,0,0,0,1.06054,0l10-10-1.06054-1.06054Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40,70.75A30.7615,30.7615,0,0,0,67.31494,25.86279l-1.332.69043A28.92622,28.92622,0,0,1,69.25,40,29.25,29.25,0,1,1,40,10.75a28.99145,28.99145,0,0,1,20.60278,8.5H54v1.5h8a.7502.7502,0,0,0,.75-.75V12h-1.5v5.78192A30.47112,30.47112,0,0,0,40,9.25a30.75,30.75,0,0,0,0,61.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcess);
export default __webpack_public_path__ + "static/media/icon_process.bc86ffd6a5af419660f89a28010f1475.svg";
export { ForwardRef as ReactComponent };